import React, { useState, useEffect } from 'react';
import { FormH1, SpinningIcon, StockDetailsContainer } from './StockDetailsElements';
import { candles } from '../LaytraderLibrary/LaytraderRequest';

function StockDetails({ token, ticker, selectedAccount }) {
    const [htmlData, setHTMLData] = useState('');
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            const response = await candles(token, ticker, selectedAccount);
            setHTMLData(response[ticker])
            setLoading(false);
        };
        fetchData();
    }, [ticker]);

    return (
        <StockDetailsContainer>
            {loading ?
                <SpinningIcon />
                : (
                    <>
                        {htmlData &&
                            <iframe style={{ width: 'inherit', height: 'inherit' }} srcDoc={htmlData}></iframe>
                        }
                    </>)}
        </StockDetailsContainer>
    );
}

export default StockDetails;